const miscellaneous = [
    {
        key: 1,
        image: require("../src/components/resources/July22_Creation.png")
    },
    {
        key: 2,
        image: require("../src/components/resources/einstein1.png")
    },
    {
        key: 3,
        image: require("../src/components/resources/Early_night.png")
    },
];

export default miscellaneous;